import "../styles/Services.css";
import { MdArrowOutward } from "react-icons/md";

export default function Services() {
    return (
        <main className="services">
            <section className="services-hero">
                <div className="services-container">
                    <h1 className="services-title">I miei Servizi</h1>
                    <p className="services-subtitle">
                        Percorsi studiati per elevare la tua performance e il tuo benessere.
                    </p>
                </div>
            </section>

            <section className="services-content">
                <div className="services-container">
                    <div className="services-grid">
                        <a href="/kick-off-performance" className="service-card" aria-label="Vai alla pagina Kick-off Performance">
                            <div className="service-header">
                                <h2 className="service-name">Kick-off Performance</h2>
                                <span className="service-cta"><MdArrowOutward aria-hidden /></span>
                            </div>
                            <p className="service-desc">
                                Ogni risultato nasce da basi solide. Con Kick-off Performance scopri il tuo stato attuale
                                e ricevi indicazioni pratiche su nutrizione, sonno, idratazione e benessere per trasformare
                                energia e performance. Il primo passo per costruire la tua strategia di successo.
                            </p>
                        </a>

                        <a href="/restart-method" className="service-card" aria-label="Vai alla pagina Restart Method">
                            <div className="service-header">
                                <h2 className="service-name">Restart Method</h2>
                                <span className="service-cta"><MdArrowOutward aria-hidden /></span>
                            </div>
                            <p className="service-desc">
                                Restart Method: il percorso per ripartire da zero, ritrovare energia, equilibrio e benessere autentico.
                                Un programma scientifico e personalizzato che integra nutrizione, movimento e gestione dello stile di vita.
                                Il primo passo per costruire la tua strategia di successo.
                            </p>
                        </a>
                    </div>
                </div>
            </section>
        </main>
    );
}